

const cpTenantDomain = "insiderealestate"; // Chili Piper subdomain
const cpRouterName = "boldtrail-demo-request"; // Chili Piper router API name
//
// No changes needed from this point
//
const cookies = document.cookie;
const cookiesArray = cookies.split('; ');
let gaCookie = "";
cookiesArray.forEach(function(arr){
      arr = arr.split('=');
      if(arr[0].includes('__as_attribution')){
         gaCookie = decodeURIComponent(arr[1]);
      }
});

jQuery(document).ready(function ($) {
   if (typeof Marionette !== "undefined") {
      console.log('getting into submit for chili');
      const mySubmitController = Marionette.Object.extend({
         initialize: function () {
            this.listenTo(Backbone.Radio.channel("forms"), "submit:response", this.actionSubmit);
         },
      actionSubmit: function (response) {
         console.log('in action for submit');
         console.log(response);
         if (!response?.data?.fields_by_key) return;
         const lead = {};
         console.log('in check for response');
         for (const [fieldName, fieldData] of Object.entries(response.data.fields_by_key)) {
            const name = fieldData.custom_name_attribute || fieldName;
            const value = fieldData.value || "";
            if (name) lead[name] = value;
         }
         console.log(gaCookie);
         console.log(typeof lead);

         console.log('Showing the lead');
         console.log(lead);
         ChiliPiper.submit(cpTenantDomain, cpRouterName, {
            map: true,
            lead: lead,
         });
         },
      });
     new mySubmitController();
   }
});